import { render, staticRenderFns } from "./ShowNumbers.vue?vue&type=template&id=1cd5b610&"
import script from "./ShowNumbers.vue?vue&type=script&lang=js&"
export * from "./ShowNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports